<template>
  <div>
    <!-- Main Dialog -->
    <v-dialog :value="value" fullscreen persistent no-click-animation>
      <v-card>
        <v-card-title ref="cardTitle">
          <span class="headline">THETAパノラマ画像アップロード</span>
          <v-spacer></v-spacer>
          <v-btn depressed color="white" fab>
            <v-icon v-on:click="close" size="30">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols>
              <div ref="previewMap"></div>
            </v-col>
            <v-col cols="auto" style="width: 350px">
              <v-row>
                <span>* は必須項目です。</span>
              </v-row>
              <v-form
                  ref="image360UploadForm"
              >
                <v-row class="div-images-upload">
                  <v-col >
                    <p>利用区分 *</p>
                    <v-chip
                        v-for="item in useTypeItems"
                        :key="item.value"
                        @click="use_type = item.value;"
                        :color="use_type == item.value ? item.color : 'default'"
                    >
                      {{item.text}}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row class="div-images-upload">
                  <v-col cols="auto">
                    <v-btn color="primary" text @click="onAddImages" :disabled="uploadBtnDisable"
                    >画像追加</v-btn
                    >
                  </v-col>
                  <v-col>
                    <h4 style="padding-top: 7px">
                      画像数：{{ inputImagesUpload.images.length }}
                    </h4>
                    <h4 style="padding-top: 7px">
                      処理済み：{{ fileCoordinates.length }}
                    </h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        v-model="note"
                        label="備考"
                        outlined
                        clearable
                        dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click.native="close()">キャンセル</v-btn>
                <v-btn depressed color="primary" @click="uploadImages" :disabled="uploadBtnDisable"
                >アップロード</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Invisible File Input -->
    <input
        ref="imagesUploader"
        class="d-none"
        type="file"
        multiple
        accept="image/*"
        @change="addImages"
        @click="$refs.imagesUploader.value = null"
    />

    <!-- Show Error Element -->
    <v-snackbar v-model="snackbar" top left timeout="-1">
      <div>アップロードできない下記のファイルを</div>
      <div>再度アップロードしてください。</div>
      <h4 v-for="(item, i) in errorFileNames" :key="i">{{ item }}</h4>
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          閉じる
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Uploading Overlay -->
    <v-dialog v-model="uploadingDialog" width="initial" persistent>
      <div class="overlay-content">
        <h4 class="mb-3">
          処理中です。戻るや画面更新やブラウザ閉じる操作を行わないでください。
        </h4>
        <div>
          <v-progress-circular
              v-if="loading === 'uploading'"
              size="22"
              indeterminate
              color="primary"
          ></v-progress-circular>
          <v-icon v-if="loading !== 'uploading'" color="green">
            mdi-check-circle
          </v-icon>
          <span>
            アップロード: {{ uploadedFilesNum }}/{{ uploadFilesNum }}ファイル
          </span>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {store} from "@/store";
import Map from "ol/Map";
import LayerGroup from "ol/layer/Group";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import View from "ol/View";
import {Circle, Fill, Stroke, Style, Text} from "ol/style";
import {transform} from "ol/proj";
import GeoJSON from "ol/format/GeoJSON";
import ExifReader from "exifreader";
import TileState from "ol/TileState";
import S3Axios from "@/utils/s3Axios";

export default {
  name: "Image360UploadDialog",
  props: ["value", "plantId", "folderId"],
  data() {
    return {
      loading: "done",
      uploadingDialog: false,
      snackbar: false,
      uploadFolderId: this.folderId,
      inputImagesUpload: {
        images: [],
      },
      errorFileNames: [],
      uploadedFilesNum: 0,
      uploadFilesNum: 0,
      useTypeItems: [
        {text: "工事", value: "1construction", color: "purple lighten-1"},
        {text: "査定", value: "2assessment", color: "green lighten-1"},
        {text: "メンテ", value: "3maintenance", color: "orange lighten-1"},
        {text: "ドローン", value: "4drone", color: "light-blue accent-4"},
      ],
      use_type: "",
      map: null,
      fileCoordinates: [],
      note: null,
      uploadBtnDisable: false,
      imagesUpload: [],
      s3Axios: new S3Axios(this.axios).s3Axios
    }
  },
  methods: {
    createFolder() {
      const body = {
        plant_id: this.plantId,
        type: '360image',
        use_type: this.use_type,
        property: {
          shooting_date: null,
        },
        note: this.note,
      };
      return this.axios.post("/api/folder", body);
    },
    onAddImages() {
      this.$refs.imagesUploader.click();
    },
    addImages(e) {
      if (!e.target.files || e.target.files.length === 0) return;
      this.uploadBtnDisable = true;
      for (const file of e.target.files) {
        // 画像が重複じゃないと画像一覧に追加する。
        if (
            !this.inputImagesUpload.images.some(
                (x) => x.name === file.name && x.size === file.size
            )
        ) {
          this.inputImagesUpload.images.push(file);
          const filename = file.name;
          const reader = new FileReader();
          reader.onload = (readerEvent) => {
            try {
              const tags = ExifReader.load(readerEvent.target.result, {expanded: true});
              const lat = tags.gps.Latitude;
              const lng = tags.gps.Longitude;
              const location = transform([lng, lat], 'EPSG:4326', 'EPSG:3857');
              this.fileCoordinates.push({coordinates: location, file_name: filename, type: this.getColorType(tags), file_width: tags.file['Image Width'].value});
              this.imagesUpload.push({name: filename});
              if (this.fileCoordinates.length === this.inputImagesUpload.images.length){
                this.fileCoordinates = JSON.parse(JSON.stringify(this.fileCoordinates));
                this.setSourcePreviewMap();
                this.uploadBtnDisable = false;
              }
            } catch (error) {
              store.showErrorDialog('画像情報の読み取りができません。システム管理者にご連絡ください。', () => {
                this.close();
              });
            }
          };
          reader.readAsArrayBuffer(file);
        }
      }
    },
    setSourcePreviewMap(){
      const features = this.fileCoordinates.map((item) => {
        return {
          type: 'Feature',
          id: item.file_name,
          geometry: {
            type: "Point",
            coordinates: item.coordinates,
          },
          properties: {
            text: item.file_name,
          },
        }
      });
      const rawSource = {
        type: "FeatureCollection",
        features: features,
      };
      const source = new VectorSource({
        features: new GeoJSON().readFeatures(rawSource),
      });
      this.map.getLayers().getArray()[1].setSource(source);
      const extent = this.calculateExtent();
      this.map.getView().animate({
        center: [(extent[2]+extent[0])/2, (extent[3]+extent[1])/2],
        zoom: 17,
        duration: 2000,
      }, () => this.setSatelliteLayer(extent));
      let selected = null;
      this.map.on('pointermove', (e) => {
        if (selected !== null){
          selected.setStyle(this.featureStyleFunction);
          selected = null;
        }
        this.map.forEachFeatureAtPixel(e.pixel, (f) => {
          const color = 'rgba(76, 175, 80, 0.7)';
          selected = f;
          selected.setStyle(
              new Style({
                image: new Circle({
                  radius: 4,
                  fill: new Fill({ color: color }),
                  stroke: new Stroke({ color: "#000", width: 3 }),
                }),
                text: new Text({
                  font: '14px Calibri,sans-serif',
                  offsetY: 19,
                  fill: new Fill({
                    color: '#fff',
                    width: 10,
                  }),
                  stroke: new Stroke({
                    color: '#000',
                    width: 3,
                  }),
                  text: f.get("text")
                }),
              })
          );
          return true;
        });
      });
    },
    calculateExtent(){
      const lngArray = this.fileCoordinates.map((o) => {return o.coordinates[0]});
      const latArray = this.fileCoordinates.map((o) => {return o.coordinates[1]});
      const maxLng = Math.max.apply(Math, lngArray);
      const maxLat = Math.max.apply(Math, latArray);
      const minLng = Math.min.apply(Math, lngArray);
      const minLat = Math.min.apply(Math, latArray);
      return [minLng-100, minLat-100, maxLng+100, maxLat+100];
    },
    getColorType(tags){
      if (tags.file['Image Width'].value < 1000){
        return 'thermal';
      }
      return 'color';
    },
    async uploadImages() {
      if (!this.$refs.image360UploadForm.validate() || !this.use_type) {
        store.showErrorDialog(
            "利用区分を選択してください。"
        );
        return;
      }
      if (
          !this.inputImagesUpload.images ||
          this.inputImagesUpload.images.length === 0
      ) {
        store.showErrorDialog(
            "「画像追加」をクリックし、アップロードしたい画像を追加してください。"
        );
        return;
      }


      if (!this.folderId) {
        try {
          const response = await this.createFolder();
          this.uploadFolderId = response.data.id;
        } catch (error) {
          store.showErrorDialog("エラーが発生しました。管理者に連絡してください。");
          return;
        }
      } else {
        this.uploadFolderId = this.folderId;
      }

      this.snackbar = false;
      this.uploadedFilesNum = 0;
      this.uploadFilesNum = this.inputImagesUpload.images.length;
      this.loading = "uploading";
      this.uploadingDialog = true;
      const uploadStatus = new Array(this.inputImagesUpload.images.length); //Value: color, thermal, error
      const success_upload_list = [];

      // アップロードURLを取得
      let presigned_urls = [];
      await this.axios.post("/api/folder/presigned-urls/image360/" + this.uploadFolderId, {images: this.imagesUpload})
          .then(response => {
            presigned_urls = response.data;
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
            this.loading = "done";
            this.uploadingDialog = false;
            this.close();
          });

      // アップロード
      if (presigned_urls.length == this.inputImagesUpload.images.length){
        for (let i = 0; i < this.inputImagesUpload.images.length; i++) {
          const presigned_url = presigned_urls[i];
          this.s3Axios
              .put(presigned_url, this.inputImagesUpload.images[i])
              .then(() => {
                uploadStatus[i] = 'success';
                success_upload_list.push(this.inputImagesUpload.images[i].name);
              })
              .catch(() => {
                uploadStatus[i] = "error";
              })
              .then(async () => {
                this.uploadedFilesNum = uploadStatus.filter(
                    (x) => x != undefined
                ).length;
                if (!uploadStatus.includes(undefined)) {
                  if (!uploadStatus.includes("error")) {
                    //全ての画像がアップロード済なら圧縮APIを呼び出す。
                    this.updateFolderProperty(this.inputImagesUpload.images[0]);
                  } else {
                    //アップロードできない画像があればアップロードできない画像一覧を表示する。
                    const errorIndexs = uploadStatus
                        .map((_, i) => i)
                        .filter((j) => uploadStatus[j] === "error");
                    this.errorFileNames = errorIndexs.map(
                        (x, i) => i + 1 + ". " + this.inputImagesUpload.images[x].name
                    );
                    const errorMsg =
                        "アップロードできない下記のファイルを再度アップロードしてください。<br>" +
                        this.errorFileNames.join("<br>");
                    store.showErrorDialog(errorMsg);
                    this.snackbar = true;
                    this.loading = "done";
                    this.uploadingDialog = false;
                  }
                }
              });
        }
      }
      else {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
        this.loading = "done";
        this.uploadingDialog = false;
      }

      this.axios
          .post('/api/image360/' + this.uploadFolderId, {'property': this.fileCoordinates})
          .catch(() => {
            store.showErrorDialog('パノラマの位置情報保存でエラーが発生しました。管理者に連絡してください。');
          });
    },
    updateFolderProperty(file) {
      const data = new FormData();
      data.append("file", file);
      data.append("type", 'image');
      this.axios
          .post("/api/folder/property/" + this.uploadFolderId, data)
          .then(() => {
            store.showSuccessDialog("アップロードが完了しました。");
            this.loading = "done";
            this.uploadingDialog = false;
            this.$emit("uploaded");
            this.close();
          });
    },
    close() {
      this.inputImagesUpload.images = [];
      this.use_type = '';
      this.$emit("input");
      this.$refs.image360UploadForm.reset();
    },
    initMap(){
      const a = window.innerHeight - this.$refs.cardTitle.offsetHeight - 24;
      this.$refs.previewMap.setAttribute('style', "height: " + a + "px");
      this.map = new Map({
        target: this.$refs.previewMap,
        layers:[
          new LayerGroup({
            title: 'BaseLayer',
            layers: [
              new TileLayer({
                zIndex: 0,
                title: "OpenStreetMap",
                source: new OSM(),
              }),
            ]
          }),
          new VectorLayer({
            title: 'VectorLayer',
            zIndex: 2,
            visible: true,
            source: new VectorSource(),
            style: this.featureStyleFunction,
          })
        ],
        view: new View({
          zoom: 5,
          center: [15550453.550049, 4257999.099720],
        })
      });
    },
    featureStyleFunction(){
      const color = 'rgba(76, 175, 80, 0.7)';
      return new Style({
        image: new Circle({
          radius: 4,
          fill: new Fill({ color: color }),
          stroke: new Stroke({ color: "#000", width: 1 }),
        }),
      });
    },
    setSatelliteLayer(extent){
      const satellite = this.getLayerByTitle('Satellite', this.map);
      if (!satellite){
        const baseLayer = this.getLayerByTitle('BaseLayer', this.map);
        if (baseLayer){
          baseLayer.getLayers().getArray().push(new TileLayer({
            title: "Satellite",
            zIndex: 1,
            source: new OSM({
              minZoom: 17,
              maxZoom: 17,
              url: '/api/tiles/{z}/{x}/{y}',
              tileLoadFunction: (tile, src) => {
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.addEventListener('loadend', function () {
                  const data = this.response;
                  if (data !== undefined) {
                    tile.getImage().src = URL.createObjectURL(data);
                  } else {
                    tile.setState(TileState.ERROR);
                  }
                });
                xhr.addEventListener('error', function () {
                  tile.setState(TileState.ERROR);
                });
                xhr.open('GET', src);
                xhr.setRequestHeader('Authorization', `Bearer ${store.state.token}`);
                xhr.send();
              }
            }),
          }));
        }
      }
      const screenExtent = this.map.getView().calculateExtent();
      const mapExtent = [
        extent[0] - 1000,
        extent[1] - 1000,
        extent[2] + 1000,
        extent[3] + 1000,
      ];
      mapExtent.forEach((position, index) => {
        if (position < screenExtent[index] && index >= 2) {
          mapExtent[index] = screenExtent[index];
        }
        if (position > screenExtent[index] && index <= 1) {
          mapExtent[index] = screenExtent[index];
        }
      });
      this.map.setView(new View({
        maxZoom: 23,
        zoom: 17,
        center: this.map.getView().getCenter(),
        extent: mapExtent,
      }));
      this.map
          .getView()
          .fit(extent);
    },
    getLayerByTitle(title, fromLayer){
      const layers = fromLayer.getLayers().getArray();
      for (const layer of layers) {
        if (layer.get("title") == title){
          return layer;
        }
        else{
          if (layer instanceof LayerGroup){
            const a = this.getLayerByTitle(title, layer);
            if (a) return a;
          }
        }
      }
      return null;
    },
  },

  mounted() {
    this.initMap();
  }
}
</script>

<style scoped>

</style>
